import { render, staticRenderFns } from "./_AttractionListItem.vue?vue&type=template&id=5a4d0782&scoped=true&"
import script from "./_AttractionListItem.vue?vue&type=script&lang=js&"
export * from "./_AttractionListItem.vue?vue&type=script&lang=js&"
import style0 from "./_AttractionListItem.vue?vue&type=style&index=0&id=5a4d0782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d0782",
  null
  
)

export default component.exports